module.exports = __webpack_public_path__ + "static/media/One More Night.1760a5e6.txt";